import { graphql } from "relay-runtime"

export const chUpdateProgressNoteAnamnesis = graphql`
  mutation chUpdateProgressNoteAnamnesisMutation($input: Ch_updateProgressNoteAnamnesisInput!) {
    ch_updateProgressNoteAnamnesis(input: $input) {
      ch_ProgressNoteMutationOutput {
        episodeOfCare {
          id
          updatedAt
        }
        progressNote {
          anamnesis
          updatedAt
        }
      }
    }
  }
`
